// Action Types
export const SUBMIT_COMPETITOR_PROFILE_V1_REQUEST =
  "SUBMIT_COMPETITOR_PROFILE_V1_REQUEST";
export const SUBMIT_COMPETITOR_PROFILE_V1_SUCCESS =
  "SUBMIT_COMPETITOR_PROFILE_V1_SUCCESS";
export const SUBMIT_COMPETITOR_PROFILE_V1_FAILURE =
  "SUBMIT_COMPETITOR_PROFILE_V1_FAILURE";

// Action Creators
export const submitCompetitorProfileV1Request = (dimension) => ({
  type: SUBMIT_COMPETITOR_PROFILE_V1_REQUEST,
  payload: dimension,
});

export const submitCompetitorProfileV1Success = (message) => ({
  type: SUBMIT_COMPETITOR_PROFILE_V1_SUCCESS,
  payload: message,
});

export const submitCompetitorProfileV1Failure = (error) => ({
  type: SUBMIT_COMPETITOR_PROFILE_V1_FAILURE,
  payload: error,
});
